import { Region } from '@moonpig/web-core-types'
import { Occasion } from '@moonpig/web-core-types-graphql'
import {
  REMINDERS_MISSION_BUTTON_CONFIG,
  REMINDERS_MISSION_BUTTON_DEFAULT_BACKGROUND,
  type RemindersMissionButtonOccasionId,
} from '@moonpig/web-core-brand/config'
import { REMINDERS_MISSION_BUTTONS_LOCALE_TEXT } from '../../../text-localisation/localeText'
import { MissionButtonReminder } from './types'

export const SUPPORTED_OCCASIONS = [
  Occasion.VALENTINES_DAY,
  Occasion.MOTHERS_DAY,
  Occasion.BIRTHDAY,
  Occasion.ANNIVERSARY,
] as const

export type SupportedOccasion = (typeof SUPPORTED_OCCASIONS)[number]

export const filterSupportedOccasions = (
  reminders: MissionButtonReminder[],
): MissionButtonReminder[] => {
  return reminders.filter(reminder =>
    SUPPORTED_OCCASIONS.includes(reminder.occasion as SupportedOccasion),
  )
}

export const getReminderMissionButtonLocaleKey = (
  occasion: SupportedOccasion,
): keyof typeof REMINDERS_MISSION_BUTTONS_LOCALE_TEXT =>
  REMINDERS_MISSION_BUTTON_CONFIG[occasion as RemindersMissionButtonOccasionId]
    .localeKey as keyof typeof REMINDERS_MISSION_BUTTONS_LOCALE_TEXT

export const getReminderMissionButtonFallbackLocaleKey = (
  occasion: SupportedOccasion,
): keyof typeof REMINDERS_MISSION_BUTTONS_LOCALE_TEXT =>
  REMINDERS_MISSION_BUTTON_CONFIG[occasion as RemindersMissionButtonOccasionId]
    .fallbackLocaleKey as keyof typeof REMINDERS_MISSION_BUTTONS_LOCALE_TEXT

export const getReminderLinkUrl = (
  reminder: MissionButtonReminder,
  storeId: Region,
): string => {
  const config =
    REMINDERS_MISSION_BUTTON_CONFIG[
      reminder.occasion as RemindersMissionButtonOccasionId
    ]
  const galleryPath = config?.galleryPath
  if (galleryPath) {
    return `/${storeId}/${galleryPath}/`
  }
  return `/${storeId}/account/reminders/${reminder.id}/`
}

export const getFirstName = (name: string): string => {
  const trimmed = name.trim()
  if (!trimmed) return ''
  return trimmed.split(' ')[0]
}

export const getOccasionBackgroundImage = (
  occasion: SupportedOccasion,
): string =>
  REMINDERS_MISSION_BUTTON_CONFIG[occasion as RemindersMissionButtonOccasionId]
    ?.backgroundImage ?? REMINDERS_MISSION_BUTTON_DEFAULT_BACKGROUND
